module.exports = __webpack_public_path__ + "static/media/12-10-basic-guide-fetch-function.9633294f.md";